import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Label, FormGroup } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { GetUserRole, ClearClientData, CheckIsUserNameExists, SaveUserDetailsforclient } from '../../../../action/Administration/administrationAction';
import { getAllResources } from '../../../../action/cultureAction';
import { GetRegularExpresions } from '../../../../action/EmployeeAction';
import ErrorGif from '../../../../Assets/images/Error.gif';

export const ValidateEmail = (Email) => {
    let RegExpEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(Email !== "" && !Email.match(RegExpEmail)){
        return false;
    }else{
        return true;
    }
}

export const ErrorText = {
    PwdErrorInfo : "The new password does not comply with security requirements.  Use a more secure password or contact your system administrator.",
    InvalidErrorInfo: "Error: You left necessary fields blank or entered invalid values. Review and correct any fields with \"!\" next to them.",
    UserIdErrorInfo: "Error: Please specify a unique user ID."
}

export default function AddModifyUser(){
    let RoleoptionsList;
    let IsNewUser = true, EditUserID = -1;
    let lUserID="",lFName="",lLastName="",lEmail="",lRole;

    /*state declaration*/
    const [componentWillMount, setComponentWillMount] = useState(true);
    const [redirectBack, setRedirectBack] = useState(false);
    const [redirectNext, setRedirectNext] = useState(false);
    const [Error, setError] = useState(false);
    const [ErrorDetails, setErrorDetails] = useState(ErrorText.InvalidErrorInfo);
    const [userIdError, setUserIdError] = useState(false);
    const [defPwdError, setDefPwdError] = useState(false);
    const [conPwdError, setConPwdError] = useState(false);
    const [fnameError, setFnameError] = useState(false);
    const [lnameError, setLnameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
   
    /*ref declaration*/
    const inputRef = useRef({});

    /*map state to props*/
    const label = useSelector(state => state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference);
    const userRoles = useSelector(state => state.InstallationsRootReducer.UserRoles);
    const getResponse = useSelector(state => state.EmployeeRootReducer);
    const ClientUserDetails = useSelector(state => state.InstallationsRootReducer.ClientSideUserData);
    const IsUserIdNameExixts = useSelector(state => state.InstallationsRootReducer.IsUserNameExists);

    /*map dispatch to props*/
    const dispatch = useDispatch();

    /*calling methods after component mounts*/
    useEffect(() => {
        if(label["ActionsAndSettings.UAText.Text"] === undefined)
            dispatch(getAllResources());
        if(componentWillMount){
            dispatch(GetUserRole());
            dispatch(GetRegularExpresions());
            setComponentWillMount(false);
        }
    },[componentWillMount]);

    const GoBack = () => {
        dispatch(ClearClientData());
        if(IsNewUser){
            setRedirectBack(true);
        }else{
            setRedirectNext(true);
        }
    }

    const isUserNameExist = async(userId) => {
        if(userId !== "")
            await dispatch(CheckIsUserNameExists(userId));
    }

    const SaveNewUser = () => {
        let Isvalid = true,IsvalidPwd = true,IsvalidEmail = true,IsvalidUserId = true;
        var UserId = inputRef.current['user_id'].value;
        var DefaultPwd = inputRef.current['default_pwd'].value;
        var ConfirmPwd = inputRef.current['confirm_pwd'].value;
        var FName = inputRef.current['first_name'].value;
        var LName = inputRef.current['last_name'].value;
        var Email = inputRef.current['email'].value;
        var selectedoption = inputRef.current['user_role'].options.selectedIndex; 
        var Role= inputRef.current['user_role'].options[selectedoption].value;
        if(UserId === "" || DefaultPwd === "" || ConfirmPwd === "" || FName === "" || LName === ""){  //empty validation
            Isvalid = false;
            if(UserId === "") setUserIdError(true);
            if(DefaultPwd === "") setDefPwdError(true);
            if(ConfirmPwd === "") setConPwdError(true);
            if(FName === "") setFnameError(true);
            if(LName === "") setLnameError(true);
        }
        IsvalidUserId = ValidateUserId(UserId);   //userid validation    
        IsvalidPwd = ValidatePwd(DefaultPwd,ConfirmPwd,UserId);  //password validation
        IsvalidEmail = ValidateEmail(Email) ? ((setEmailError(false),true)) : ((setEmailError(true),false)); //email validation 
        if(Isvalid && IsvalidPwd && IsvalidEmail && IsvalidUserId){
            var Data = {
                "userId" : -1,
                "IsNewUser" : IsNewUser,
                "userName" : UserId,
                "pwd": DefaultPwd,
                "firstName" : FName,
                "lastName" : LName,
                "emailAddress" : Email,
                "role" : Role
            }
            if (!IsUserIdNameExixts|| !IsNewUser) { //user id already exists validation
                dispatch(SaveUserDetailsforclient(Data));
                setRedirectNext(true);
            } else {
                setError(true);
                setErrorDetails(ErrorText.UserIdErrorInfo);
                setUserIdError(true);
                inputRef.current['default_pwd'].value = "";
                inputRef.current['confirm_pwd'].value = "";
            }
        }else{
            setError(true);
        }
    }

    const SaveExistingUser = () => {
        let Isvalid = true,IsvalidEmail = true;
        var UserId = lUserID;
        var FName = inputRef.current['first_name'].value;
        var LName = inputRef.current['last_name'].value;
        var Email = inputRef.current['email'].value;
        var selectedoption = inputRef.current['user_role'].options.selectedIndex; 
        var Role= inputRef.current['user_role'].options[selectedoption].value;
        if(FName === "" || LName === ""){  //empty validation
            Isvalid = false;
            if(FName === "") setFnameError(true);
            if(LName === "") setLnameError(true);
        }
        IsvalidEmail = ValidateEmail(Email) ? ((setEmailError(false),true)) : ((setEmailError(true),false)); //email validation 
        if(Isvalid && IsvalidEmail){
            var Data = {
                "userId" : EditUserID,
                "IsNewUser" : IsNewUser,
                "userName" : UserId,
                "firstName" : FName,
                "lastName" : LName,
                "emailAddress" : Email,
                "role" : Role
            }
            dispatch(SaveUserDetailsforclient(Data));
            setRedirectNext(true);
        }else{
            setError(true);
        }
    }

    const Finish = () => {
        setError(false);
        setErrorDetails(ErrorText.InvalidErrorInfo);
        setUserIdError(false);
        setDefPwdError(false);
        setConPwdError(false);
        setFnameError(false);
        setLnameError(false);
        setEmailError(false);
        if(IsNewUser){
            SaveNewUser();
        }else{
            SaveExistingUser();
        }
    }

    const ValidateUserId = (UserId) => {
        var RegExpOnlySpecialCharacters = /^[^a-zA-Z0-9]+$/;
        var RegExpLogonNamePattern = getResponse.RegularExpression[5];
        var RegexpLogonNameLength = getResponse.RegularExpression[4];
        if(UserId === ""){
            return false;
        }else if(UserId !== "" && UserId.match(RegExpOnlySpecialCharacters)){
            setUserIdError(true);
            return false;
        }else if(UserId !== "" && (!UserId.match(RegExpLogonNamePattern) || !UserId.match(RegexpLogonNameLength))) {
            setUserIdError(true);
            return false;
        }else{
            return true;
        }
    }

    const ValidatePwd = (DefaultPwd,ConfirmPwd,UserId) => {
        var RegExpPasswordPattern = getResponse.RegularExpression[1];
        var RegexpPasswordLength = getResponse.RegularExpression[0];
        var RegexpPasswordDuplicatePattern = /([a-z])\1/i;
        var RegexpPasswordDuplicateAllowed =getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = getResponse.RegularExpression[2];
        if(DefaultPwd === "" || ConfirmPwd === ""){
            return false;
        }else{
            if(DefaultPwd !== ConfirmPwd){ //mismatch
                setConPwdError(true);
                return false;
            }else if(!DefaultPwd.match(RegExpPasswordPattern) || !DefaultPwd.match(RegexpPasswordLength)){ //not matching password policy
                setDefPwdError(true);
                setErrorDetails(ErrorText.PwdErrorInfo);
                return false;
            }else if(RegexpPasswordDuplicateAllowed === "False" && DefaultPwd.match(RegexpPasswordDuplicatePattern)){ //repeating characters in password
                setDefPwdError(true);
                setErrorDetails(ErrorText.PwdErrorInfo);
                return false;
            }else if(RegexpPasswordLogOnNameForPasswordAllowed === "False" && UserId !== "" && DefaultPwd.toLowerCase().indexOf(UserId.toLowerCase()) !== -1){ //password cannot contain user id
                setDefPwdError(true);
                setErrorDetails(ErrorText.PwdErrorInfo);
                return false;
            }else{
                return true;
            }
        }
    }

    if(userRoles !== undefined && userRoles !== "" && userRoles.length !== 0) {
        RoleoptionsList = userRoles.filter(el => el.roleID === 4).map(el =>(
            <option id={el.roleID} key={el.roleID}>{el.roleName}</option>
        ));
    }

    if(ClientUserDetails !== undefined && ClientUserDetails !== null && ClientUserDetails.userName !== undefined){
        var Data = ClientUserDetails;
        lUserID = Data.userName;
        lFName = Data.firstName;
        lLastName = Data.lastName;
        lEmail = Data.emailAddress;
        lRole = Data.role;
        IsNewUser = Data.IsNewUser;
        EditUserID = Data.userId;
    }

    if(redirectBack){
        return <Redirect to={"/SystemAdmin/Administration"} />
    }

    if(redirectNext){
        return <Redirect to={"/SystemAdmin/AddModifyUserSummary"} />
    }

    return(
        <div className="dbd_container">
            <div className="admin_page_titlebar">
                <div className="admin_subheader">
                    <h2 className="dbd_sub_heading">
                        { IsNewUser ? 
                            label['AdministrationTHN.Text'] !== undefined ? label['Addministration.AddUserProfile.Text']:"Add User Profile"
                            : label['AdministrationTHN.Text'] !== undefined ? label['Administration.EditUserProfile.Text']:"Edit User Profile"
                        }
                    </h2>
                </div>
            </div>
            { Error ? 
                    <p className="error_msg" style={{paddingLeft:"15px"}}> <img src={ErrorGif} alt="Trane Logo" /> {ErrorDetails}</p> 
                    : "" }
            <div style={{padding:'0px 20px 0px 20px'}}>
                <div style={{display:'table'}}>
                    <div className="add_modifi form_group ">
                        <Label className="Custom_label">
                            {label['EnumUserChangeLog.cboForColumn.1.Text'] !== undefined ? label['EnumUserChangeLog.cboForColumn.1.Text']+"*":"UserId*"} 
                        </Label>
                        { IsNewUser ? 
                            <><input ref={el => inputRef.current['user_id'] = el} type="text" defaultValue={lUserID} className="add_modify custom_input default-input" onBlur={(el) => isUserNameExist(el.target.value)}/>
                            <span className="ErrorMark" hidden={!userIdError} >!</span></>
                            : <label className="Custom_label">{lUserID}</label> 
                        }
                    </div>
                    { IsNewUser ?
                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">
                                {label['ApplyTESLicense.lblDefaultPwd.Text'] !== undefined ? label['ApplyTESLicense.lblDefaultPwd.Text'] : "Default Password*"}
                            </Label>
                            <input ref={el => inputRef.current['default_pwd'] = el} type="password" className="add_modify custom_input default-input" />
                            <span className="ErrorMark" hidden={!defPwdError} >!</span>
                        </div> 
                        : <></> 
                    }
                    { IsNewUser ? 
                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">
                                {label['ApplyTESLicense.lblConfirmPwd.Text'] !== undefined ? label['ApplyTESLicense.lblConfirmPwd.Text'] : "Confirm Password*"}
                            </Label>
                            <input ref={el => inputRef.current['confirm_pwd'] = el} type="password" className="add_modify custom_input default-input" />
                            <span className="ErrorMark" hidden={!conPwdError} >!</span>
                        </div> 
                        : <></> 
                    }
                    <div className="add_modifi form_group ">
                        <Label className="Custom_label">
                            {label['ApplyTESLicense.lblFirstName.Text'] !== undefined ? label['ApplyTESLicense.lblFirstName.Text'] : "First Name*"}
                        </Label>
                        <input ref={el => inputRef.current['first_name'] = el} type="text" defaultValue={lFName} className="add_modify custom_input default-input" />
                        <span className="ErrorMark" hidden={!fnameError} >!</span>
                    </div>
                    <div className="add_modifi form_group ">
                        <Label className="Custom_label">
                            {label['ApplyTESLicense.lblLastName.Text'] !== undefined ? label['ApplyTESLicense.lblLastName.Text'] : "Last Name*"}
                        </Label>
                        <input ref={el => inputRef.current['last_name'] = el} type="text" defaultValue={lLastName} className="add_modify custom_input default-input" />
                        <span className="ErrorMark" hidden={!lnameError} >!</span>
                    </div>
                    <div className="add_modifi form_group ">
                        <Label className="Custom_label">
                            {label['AddAlarmEmailRouting2.ColHeader.Text'] !== undefined ? label['AddAlarmEmailRouting2.ColHeader.Text'] : "E-mail Address"}
                        </Label>
                        <input ref={el => inputRef.current['email'] = el} type="text" defaultValue={lEmail} className="add_modify custom_input default-input" />
                        <span className="ErrorMark" hidden={!emailError} >!</span>
                    </div>
                    <legend className="form_sub_title">User Role</legend>
                    <div className="add_modifi form_group ">
                        <Label className="Custom_label">User Role*</Label>
                        <select ref={el => inputRef.current['user_role'] = el} defaultValue={lRole} className="add_modify Modal_input_regular">
                            {RoleoptionsList}   
                        </select>
                    </div>
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" onClick={() => GoBack()}> 
                                {label['ManageTroubleshootingManuals.BackButton.Text'] !== undefined ? label['ManageTroubleshootingManuals.BackButton.Text']: "< Back"} 
                            </Button>
                            <Button className="btn-success btn-md" onClick={() => Finish()}>
                                {label['AddBuildingCustomAttributes.btnNext.Text'] !== undefined ? label['AddBuildingCustomAttributes.btnNext.Text'] : "Next >"}
                            </Button>
                        </Col>
                    </FormGroup>
                </div>
            </div>
        </div>
    );
}
